import React, { useContext, useState } from 'react';
import { Vessel } from '../types/ViewModel/Vessel/Vessel';
import { ContextProps } from '../types/ContextProps';

type VesselContextType = {
    vesselList: Vessel[];
    filteredVesselList: Vessel[];
    selectedVessel: Vessel | null;
    selectedListVessel: Vessel | null;
    includeInactiveVessels: boolean;
    isVesselListRetrieved: boolean;
    isVesselDataRetrieved: boolean;
    vessel: Vessel | null;
    loadingExcelFile: boolean;
    setVesselList: (vessels: Vessel[]) => void;
    setFilteredVesselList: (vessels: Vessel[]) => void;
    setSelectedVessel: (vessel: Vessel | null) => void;
    setSelectedListVessel: (vessel: Vessel | null) => void;
    setIncludeInactiveVessels: (includeInactiveVessels: boolean) => void;
    setIsVesselListRetrieved: (isRetrieved: boolean) => void;
    setIsVesselDataRetrieved: (isRetrieved: boolean) => void;
    setVessel: (vessel: Vessel) => void;
    setLoadingExcelFile: (isLoading: boolean) => void;
};

export const VesselContext = React.createContext<VesselContextType>(undefined!);

export const VesselProvider = ({ children }: ContextProps) => {
    const [vesselList, setVesselList] = useState<Vessel[]>([]);
    const [filteredVesselList, setFilteredVesselList] = useState<Vessel[]>([]);
    const [selectedVessel, setSelectedVessel] = useState<Vessel | null>(null);
    const [selectedListVessel, setSelectedListVessel] = useState<Vessel | null>(null);
    const [includeInactiveVessels, setIncludeInactiveVessels] = useState<boolean>(false);
    const [isVesselListRetrieved, setIsVesselListRetrieved] = useState<boolean>(false);
    const [isVesselDataRetrieved, setIsVesselDataRetrieved] = useState<boolean>(false);
    const [vessel, setVessel] = useState<Vessel | null>(null);
    const [loadingExcelFile, setLoadingExcelFile] = useState<boolean>(false);

    return (
        <VesselContext.Provider
            value={{
                vesselList,
                setVesselList,
                selectedVessel,
                setSelectedVessel,
                selectedListVessel,
                setSelectedListVessel,
                filteredVesselList,
                setFilteredVesselList,
                isVesselListRetrieved,
                setIsVesselListRetrieved,
                isVesselDataRetrieved,
                setIsVesselDataRetrieved,
                vessel,
                setVessel,
                includeInactiveVessels,
                setIncludeInactiveVessels,
                loadingExcelFile,
                setLoadingExcelFile,
            }}
        >
            {children}
        </VesselContext.Provider>
    );
};

export const useVesselStore = () => useContext(VesselContext);
